<h1 nxHeadline size="s" class="nx-font-weight-semibold nx-margin-bottom-2m">Summary</h1>

<!-- //////////////////////////////////////////////////////////////////// -->
<!-- Agent Information -->
@if (showAgentInfo) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Agent Information </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <div nxLayout="grid nopadding">
        <app-agents-information [agentData]="agentData"> </app-agents-information>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- //////////////////////////////////////////////////////////////////// -->
<!-- Issuance Information -->
@if (showIssuanceInfo) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit">
          Issuance Information
          @if (showEditButton) {
          <button nxPlainButton type="button" (click)="goToIssueDeclaration()">EDIT</button>
          }
        </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <div nxLayout="grid nopadding">
        <app-issuance-information [progressType]="progressType" [issuanceInfo]="issuanceInfo" [isTypeIssuance]=true></app-issuance-information>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- //////////////////////////////////////////////////////////////////// -->
<!-- Customer Partner -->
@if (showCustomerPartner) {
  <nx-accordion variant="light">
    <nx-expansion-panel [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Customer Partner
            @if (showEditButton) {
            <button nxPlainButton type="button" (click)="goToCPScreen()">EDIT</button>
            }
        </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <app-customer-partner-details [viewOnly]="true" [cpType]="'FOUND'" [hideEdit]="true" [cpDetails]="cpData" [lov]="lov" [isSummaryPage]="isCalculateAge()" [pCodeInfo]="issuanceInfo"> </app-customer-partner-details>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- ///////////////////////////////////////////////////////////////////// -->
<!-- Referral Details -->
@if (!showSalesmanID &&showReferralDetails) { <!-- agentData.sundriesAgent -->
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Referral Details </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <div nxLayout="grid nopadding">
        <div nxRow>
          <div nxCol="12,12,6">
            <form [formGroup]="referralForm">
              <nx-formfield label="Referral ID No.">
                <input nxInput type="text"
                 appToUpperCase formControlName="referralId" 
                 style="text-transform: uppercase" 
                 (blur)="onBlurReferralId()" 
                 [appMaxLength]="15" 
                 />
                <nx-error nxFormfieldError>
                  <strong>Please enter Referral ID No.</strong>
                </nx-error>
              </nx-formfield>
            </form>
          </div>
        </div>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
}
<!-- Salesman ID -->

@if (showSalesmanID) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Salesman ID </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <div nxLayout="grid nopadding">
        <div nxRow>
          <div nxCol="12,12,6">
            <form [formGroup]="salesmanIdForm">
              <nx-formfield label="Salesman ID">
                <input nxInput type="text"
                 appToUpperCase formControlName="frStaffNo" 
                 style="text-transform: uppercase" 
                 (blur)="onBlurSalesmanId()" 
                 [appMaxLength]="20" />
              </nx-formfield>
            </form>
          </div>
        </div>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- ////////////////////////////////////////////// -->
<!-- Coverage -->
@if (showCoverage) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordione_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Coverage
            @if (showEditButton) {
            <button nxPlainButton type="button" (click)="goToCoverageScreen()">EDIT</button>
            }
        </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <app-coverage-summary [coverageInfo]="coverageInfo" [isRTP]="isRTP"></app-coverage-summary>
    </nx-expansion-panel>
  </nx-accordion>
}


<!-- Renewal Assistance -->
@if (showRenewalAssistant) {
<form [formGroup]="renewalAssistanceForm">
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Renewal Assistance </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <nx-checkbox formControlName="autoRenewalInd"
        (checkboxChange)="onChangeRenewalAssistanceForm('autoRenewalInd', $event.checked)"
        class="nx-margin-bottom-2m nx-margin-top-xs"> Renewal Assistance </nx-checkbox>
      <div *ngIf="renewalAssistanceCheckbox">
        <div nxLayout="grid nopadding">
          <div nxRow>
            <div nxCol="12,12,6">
              <nx-formfield label="Payment Mode">
                <nx-dropdown formControlName="creditCardType" (selectionChange)="saveSummaryStep()">
                  <ng-container *ngFor="let mode of lov.cardTypeList">
                    <nx-dropdown-item [value]="mode.code">{{ mode.descp }}</nx-dropdown-item>
                  </ng-container>
                </nx-dropdown>
                <nx-error nxFormfieldError>
                  <strong>Please enter Payment mode.</strong>
                </nx-error>
              </nx-formfield>
            </div>

            <div nxCol="12,12,6">
              <nx-formfield label="Credit Card No">
                <input formControlName="creditCardNo" nxInput [appOnlyNumber]="true" maxlength="16"
                  (change)="saveSummaryStep()" />
                <span nxFormfieldHint class="std-ta-left">eg. 5500000000000004</span>
                <nx-error nxFormfieldError *ngIf="renewalAssistanceForm.controls['creditCardNo']?.hasError('required')">
                  <strong>Please enter Credit Card No.</strong>
                </nx-error>
                <nx-error nxFormfieldError *ngIf="renewalAssistanceForm.controls['creditCardNo']?.hasError('pattern')">
                  <strong>Invalid Credit Card No.</strong>
                </nx-error>
              </nx-formfield>
            </div>
          </div>
        </div>

        <p nxCopytext="normal" class="nx-margin-bottom-2m">Credit Card Expiry Date</p>

        <div nxLayout="grid nopadding">
          <div nxRow>
            <div nxCol="12,12,6">
              <div nxLayout="grid nopadding" class="grid_remove_padding">
                <div nxRow>
                  <div nxCol="5" class="renewal_monthyear">
                    <nx-formfield label="Month">
                      <nx-dropdown formControlName="creditCardExpMonth" (selectionChange)="saveSummaryStep()">
                        <ng-container *ngFor="let month of monthList">
                          <nx-dropdown-item [value]="month.code">{{ month.code }}</nx-dropdown-item>
                        </ng-container>
                      </nx-dropdown>
                      <nx-error nxFormfieldError>
                        <strong>Please enter Month.</strong>
                      </nx-error>
                    </nx-formfield>
                  </div>

                  <div nxCol="2" class="renewal_monthyear">
                    <p nxCopytext="large">/</p>
                  </div>

                  <div nxCol="5" class="renewal_monthyear">
                    <nx-formfield label="Years">
                      <nx-dropdown formControlName="creditCardExpYear" (selectionChange)="saveSummaryStep()">
                        <ng-container *ngFor="let year of yearList">
                          <nx-dropdown-item [value]="year.code">{{ year.name }}</nx-dropdown-item>
                        </ng-container>
                      </nx-dropdown>
                      <nx-error nxFormfieldError>
                        <strong>Please enter Year.</strong>
                      </nx-error>
                    </nx-formfield>
                  </div>
                </div>
              </div>
            </div>

            <div nxCol="12,12,6">
              <nx-formfield label="Name on Card">
                <input formControlName="creditCardHolderName" appToUpperCase nxInput maxlength="100"
                  (change)="saveSummaryStep()" />
                <nx-error nxFormfieldError>
                  <strong>Please enter Name on Card.</strong>
                </nx-error>
              </nx-formfield>
            </div>
          </div>
          <div nxRow>
            <div nxCol="12,12,6">
              <nx-formfield label="Renewal Assistance Start Date">
                <input nxDatefield nxInput [datepicker]="myDatepicker100" formControlName="autoRenewalStartDt"
                  (dateChange)="onDateChange($event)" />
                  <span nxFormfieldHint>DD/MM/YYYY</span>

                <nx-datepicker-toggle [for]="myDatepicker100" nxFormfieldSuffix></nx-datepicker-toggle>
                <nx-datepicker #myDatepicker100></nx-datepicker>
                <nx-error *ngIf="renewalAssistanceForm.controls['autoRenewalStartDt']?.hasError('required')"
                  nxFormfieldError>
                  <strong>Please enter Renewal Assistance Start Date</strong>
                </nx-error>
              </nx-formfield>
            </div>
          </div>
        </div>

        <nx-checkbox formControlName="termsOfUse">Term of Use</nx-checkbox>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
</form>
}

<!-- ////////////////////////////////////////////// -->
<!-- Historical Claim -->
@if (showHistoricalClaim) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Allianz’s Historical Claim </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <table nxTable class="summary_table" aria-label="claimDetailsTableDesc">
        <tr nxTableRow>
          <td nxTableCell>
            <span nxCopytext="normal">Client Claim History</span>
          </td>
          <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">{{ clientClaimHistory }}</span>
          </td>
        </tr>
        <tr nxTableRow>
          <td nxTableCell>
            <span nxCopytext="normal">Vehicle Claim History</span>
          </td>
          <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">{{ vehicleClaimHistory }}</span>
          </td>
        </tr>
      </table>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- ////////////////////////////////////////////// -->
<!-- Premium Information -->
@if (showPremiumInformation) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Premium Information </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <app-premium-information [premiumInfo]="premiumInfo" [isRTP]="isRTP" [isIssuance]="isIssuance" 
      [isEndorsement]="isEndorsement" [productCode]="issuanceInfo.issuance.productCode" 
      [coverageInfo]="coverageInfo"> </app-premium-information>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- ////////////////////////////////////////////// -->
<!-- Refer Case (if any) -->
@if (showReferCase) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Refer Case (if any) </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <form [formGroup]="referCaseForm">
        <div nxLayout="grid nopadding" class="grid_remove_padding">
          <div nxRow>
            <div nxCol="12,12,4" class="nx-margin-bottom-2m">
              <nx-checkbox formControlName="waiveLoadInd" (change)="saveSummaryStep()">Refer Waive Load Ind.</nx-checkbox>
            </div>
            <div nxCol="12,12,4" class="nx-margin-bottom-2m">
              <nx-checkbox formControlName="waiveExcessInd" (change)="saveSummaryStep()">Refer Waive Excess Ind.</nx-checkbox>
            </div>
            <div nxCol="12,12,4" class="nx-margin-bottom-2m">
              <nx-checkbox formControlName="underwritingInd" (change)="saveSummaryStep()">Refer for Underwriting</nx-checkbox>
            </div>
          </div>
        </div>

        <nx-formfield label="Referral Remarks">
          <textarea required nxInput type="text" appToUpperCase formControlName="remarks" style="text-transform: uppercase" #remarksCount [appMaxLength]="100" cdkTextareaAutosize (blur)="saveSummaryStep()"></textarea>
          @if (remarksCount.value?.length === 0) {
          <span nxFormfieldHint>Max. 100 Characters</span>
          }

          @if (remarksCount.value.length > 0) {
          <span nxFormfieldHint>{{ 100 - (remarksCount.value.length || 0) }} {{ 'COMMON.CHAR_REMAINING' | translate }}</span>
          }
          <nx-error nxFormfieldError>
            <strong>Please enter referral remarks.</strong>
          </nx-error>
        </nx-formfield>
      </form>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- OCC Section (to be move to new component) -->

<!-- ////////////////////////////////////////////// -->
<!-- Payment -->
@if (showPayment) {
  <div #paymentSectionStart>
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Payment </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <app-payment [payment]="payment"></app-payment>

    </nx-expansion-panel>
  </nx-accordion>
</div>
}
<!-- ////////////////////////////////////////////// -->
<!-- Road Tax Payable -->
@if (showRoadTaxPayable) {
  <app-road-tax-payable (onChangePaymentSection)="onChangePaymentSection()" [parentForm]="summaryForm" [data]="roadTaxPayable">
  </app-road-tax-payable>
}
<!-- ////////////////////////////////////////////// -->
<!-- Upsell Product -->
@if (showUpsellProduct) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Upsell Product </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <app-upsell-product [parentForm]="summaryForm"></app-upsell-product>
    </nx-expansion-panel>
  </nx-accordion>
}
<!-- ////////////////////////////////////////////// -->
<!-- Payment Information -->
@if (showPaymentInformation) {
  <app-payment-information [premiumInfo]="paymentInformation"></app-payment-information>
}
<!-- ////////////////////////////////////////// -->
<!-- Payment Details -->
@if (showPaymentDetails) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Payment Details </nx-expansion-panel-title>
      </nx-expansion-panel-header>
      <app-payment-details [userInfo]="userInfo" [agentInfo]="agentData" (updatePaymentList)="updatePaymentList($event)"
      [paymentList]="paymentList" [paymentInfo]="paymentInformation">
      </app-payment-details>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- Endorsement Checklist (to be move to new component) -->
<!-- ////////////////////////////////////////////////// -->
<!-- Checklist -->
@if (showChecklist) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Checklist </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <div nxLayout="grid nopadding" class="grid_remove_padding">
        <!-- Amendment of Period, Extra Benefits, NCD Allowed, NCD Amendment, NCD Withdraw, Reinstatement of Extra Coverage, Revision of Sum Insured -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">1</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Insured or Agent Authorised letter / form / email (with contact number).</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NCD Allowed, NCD Amendment -->
        <div nxRow>
          <div nxCol="12">
            <p nxCopytext="medium" class="nx-margin-bottom-2m">
              <i>Note: Insured IC copy/E-payment form/copy of bank book-statement required (if refund involved).</i>
            </p>
          </div>
        </div>

        <!-- Amendment of Period -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">2</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Copy of VOC / Registration card (for brand new only).</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cancellation by Insured, Hire Purchase/Employers' Loan/Leasing, Named Driver -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">1</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Insured Authorised letter/form/email (with contact number).</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12">
            <p nxCopytext="medium" class="nx-margin-bottom-2m">
              <i>Note: Warranted no claim as at todate.</i>
            </p>
          </div>
        </div>

        <!-- Change of Bancassurance Details -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">1</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Internal email communication for changes.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Change of Vehicle Chassis No, Change Of Vehicle Registration Number, Change of Make & Model -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">1</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Insured or Agent Authorised letter/form/email (with contact number) OR</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Change of Vehicle Chassis No, Change Of Vehicle Registration Number, Change of Make & Model -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">2</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Copy of VOC/Registration card.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Extra Benefits, Named Driver, Revision of Sum Insured -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">2</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Vehicle inspection done.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Extra Benefits, Named Driver -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">3</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Warranted no claim as at todate.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12">
            <p nxCopytext="medium" class="nx-margin-bottom-2m">
              <i>Note: Inclusion of extra benefits will only be allowed warranted no claim as at the date of endt.</i>
            </p>
          </div>
        </div>

        <!-- Named Driver -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">4</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Copy of I/C / passport.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NCD Withdraw -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">2</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Claim/damage to the vehicle.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12">
            <p nxCopytext="medium" class="nx-margin-bottom-2m">
              <i>Note: Insured IC copy/Epayment form/copy of bank book-statement required (if refund involved).</i>
            </p>
          </div>
        </div>

        <!-- Reinstatement of Extra Coverage -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">2</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Inspection done (required only if exceeded 14 days).</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Revision of Sum Insured -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">3</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Requested by Bank/Finance owner.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Revision of Sum Insured -->
        <div nxRow class="nx-margin-bottom-2m">
          <div nxCol="2,2,1" class="checklist">
            <span nxCopytext="normal">4</span>
          </div>
          <div nxCol="10,10,11" class="checklist">
            <span nxCopytext="normal">Purchase invoice - for new cases & vehicles from Langkawi/Labuan only.</span>
            <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
              <div nxRow>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">Yes</nx-radio>
                </div>
                <div nxCol="4,4,3,2" class="checklist_radio">
                  <nx-radio name="yesno">No</nx-radio>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12">
            <p nxCopytext="medium" class="nx-margin-bottom-2m">
              <i>Note: Warranted no claim as at todate.</i>
            </p>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12">
            <nx-formfield label="Remarks">
              <textarea nxInput type="text" #inputToCount maxlength="100" cdkTextareaAutosize></textarea>
              <span nxFormfieldHint>Max. 100 Characters</span>
            </nx-formfield>
          </div>
        </div>
      </div>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- Endorsement Narration (to be move to new component) -->

<!-- ///////////////////////////////////////////////// -->
<!-- Endorsement Narration -->
@if (showEndorsementNarration) {
  <nx-accordion variant="light">
    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
      <nx-expansion-panel-header>
        <nx-expansion-panel-title class="accordion_edit"> Endorsement Narration </nx-expansion-panel-title>
      </nx-expansion-panel-header>

      <app-endorsement-narration></app-endorsement-narration>
    </nx-expansion-panel>
  </nx-accordion>
}

<!-- //////////////////////////////////////////////////////////////////// -->
@if (showEndorsementErrMessage) {
  <p nxCopytext="medium" class="nx-margin-top-2m">
    <i>* You will not be able to save as quotation, please proceed to generate Endorsement if details has been finalised.</i>
  </p>
}

<div class="button-container-general nx-margin-top-50 nx-margin-bottom-3xl">
  @if(!isUpdatePayment) {
  <a><button nxButton="secondary" type="button" (click)="goBack()">BACK</button></a>
  }

  <button *ngIf="!isRTP && !isUpdatePayment && !isCancelReplaceCoverNote" nxButton="primary" type="button" (click)="generate()" [disabled]="isDisableGenerateButton()">Generate e-Quotation</button>

  @if(isUpdatePayment) {
  <button nxButton="primary" type="button" (click)="savePayment()" [disabled]="isDisableUpdatePayment()">SAVE</button>
  }

  @if(!isUpdatePayment && !isRSEUser) {
    @if (!this.issueOnQuotation) {
      <a><button nxButton="primary" type="button" (click)="checkORIXOverwiteBeforeSendJPJ()" [disabled]="isDisableSendToJPJ()">SEND TO JPJ</button></a>
    }
  }

  <button *ngIf="!isRTP && !isUpdatePayment" nxButton="primary" type="button" (click)="uploadDocument()" [disabled]="isDisableUpload()">UPLOAD DOCUMENT</button>
</div>
